<!-- Default accordion used in the app, implementions the AccordionBase. -->

<script lang="ts" setup>
defineProps<{ title: string, expanded: boolean }>()
const emit = defineEmits<{ (e: 'accordion-toggle', state: boolean): void }>()
</script>

<template>
  <AccordionBase :expanded="expanded" @accordion-toggle="() => emit('accordion-toggle', expanded)">
    <template #title>
      <div class="accordion__title">
        {{ title }}
      </div>
    </template>

    <template #icon>
      <div class="accordion__icon" :class="{ expanded }">
        <span />
        <span />
      </div>
    </template>

    <template #content>
      <div class="accordion__content">
        <slot />
      </div>
    </template>

    <template #divider>
      <div class="accordion__divider" />
    </template>
  </AccordionBase>
</template>

<style lang="scss" scoped>
.accordion {
  &__title {
    padding-block: var(--spacing-xs);
    text-align: left;
  }

  &__icon {
    position: relative;
    pointer-events: none;
    width: 1.2rem;
    height: 1.2rem;

    span {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1.2rem;
      height: 0.15rem;
      border-radius: 0.25rem;
      background: var(--black);
      transition: transform ease-in-out 0.25s;
      transform: translate(-50%, -50%);

      &:last-of-type {
        transform: translate(-50%, -50%) rotate(90deg);
      }
    }

    &.expanded {
      span:last-of-type {
        transform: translate(-50%, -50%) rotate(0deg);
      }
    }
  }

  &__divider {
    width: 100%;
    height: 1px;
    background-color: var(--gray);
  }

  &__content {
    padding-top: var(--spacing-m);
    padding-bottom: var(--spacing-xl);
  }
}
</style>
